module.exports = __webpack_public_path__ + "img/wave-1.8a0e1da4.svg";